// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1765d909","80":"cac80949","138":"e09915ba","301":"2f9fb66a","313":"8390b064","325":"abefb966","329":"8bff5e10","500":"2c49d088","521":"8f1e411e","524":"794aa085","656":"d61fd237","696":"a7d8ae8f","783":"59cef5b0","872":"9df6d128","981":"688853e7"}[chunkId] + ".chunk.css";
};